import { render } from "./RequisitesForm.vue?vue&type=template&id=679b579e&ts=true"
import script from "./RequisitesForm.vue?vue&type=script&lang=ts"
export * from "./RequisitesForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__